module.exports = __webpack_public_path__ + "static/media/fold.d506d846.png";